import { atom } from 'jotai'
import { TAuthentication } from '../types'

export const authenticationState = atom<TAuthentication>({
    baId: '',
    customer: {
        href: ''
    },
    expired: false,
    href: '',
    log_id: null,
    duration: '',
    token: '',
    loginTokenSecondsLeft: 0
})
